import mutations from './mutations';
import actions from './actions';
import getters from './getters';
import Flights from "./interfaces/flights";
import SelectedFlight from "./interfaces/selectedFlight";

export interface FlightState {
    availableFlights: Flights[],
    selectedFlight: SelectedFlight,
    toggleState: {
        showMore: boolean,
        showMoreFlights: boolean,
        shownItems: number
    },
}

export const flightsInitialState: FlightState = {
    availableFlights: [],
    selectedFlight: {
        id: '',
        type: ''
    },
    toggleState: {
        showMore: false,
        showMoreFlights: false,
        shownItems: 5
    }
}

export default {
    namespaced: false,
    state: flightsInitialState,
    mutations,
    actions,
    getters
}
